import { createAction, props } from '@ngrx/store';
import { TranscriptEntry } from '../models/transcript-entry.type';
import { RequestMediaFailedReason } from '../enums/request-media-failed-reason.enum';

export type DeviceActivationFailedProps = {
  reason: RequestMediaFailedReason;
  blockedByUser: boolean;
};

export function createVideoActions(type: string) {
  return {
    initializationTriggered: createAction(
      `[${type}] Initialization Triggered `,
      props<{ videoSelector: string }>(),
    ),
    initializeVideoSucceeded: createAction(`[${type} Effect] Initialize Video Succeeded`),
    initializeVideoErrored: createAction(`[${type} Effect] Initialize Video Errored`),
    connectVideoSucceeded: createAction(`[${type} Effect] Connect Video Succeeded`),
    connectVideoErrored: createAction(
      `[${type} Effect] Connect Video Errored`,
      props<{ error: any }>(),
    ),
    playClicked: createAction('[Project Video Error] Video Play Clicked'),
    autoPlaySucceeded: createAction(`[${type} Effect] Auto Play Succeeded`),
    manualPlaySucceeded: createAction(`[${type} Effect] Manual Play Succeeded`),
    autoPlayErrored: createAction(`[${type} Effect] Auto Play Errored`, props<{ error: any }>()),
    manualPlayErrored: createAction(
      `[${type} Effect] Manual Play Errored`,
      props<{ error: any }>(),
    ),
    microphoneAvailable: createAction(`[${type} Effect] Microphone Available`),
    microphoneNotAvailable: createAction(`[${type} Effect] Microphone Not Available`),
    cameraAvailable: createAction(`[${type} Effect] Camera Availabile`),
    cameraNotAvailable: createAction(`[${type} Effect] Camera Not Available`),
    restoreMicrophoneCameraActiveSucceeded: createAction(
      `[${type} Effect] Restore Microphone Camera Active Succeeded`,
    ),
    restoreMicrophoneCameraActiveFailed: createAction(
      `[${type} Effect] Restore Microphone Camera Active Failed`,
      props<{ error: any }>(),
    ),
    maybeLaterClicked: createAction(`[${type}] Maybe Later Clicked`),
    turnMicrophoneOnClicked: createAction(`[${type}] Turn Microphone On Clicked`),
    turnMicrophoneOnSucceeded: createAction(`[${type} Effect] Turn Microphone On Succeeded`),
    turnMicrophoneOnFailed: createAction(
      `[${type} Effect] Turn Microphone On Failed`,
      props<DeviceActivationFailedProps>(),
    ),
    turnMicrophoneOnFailedAsNotAvailable: createAction(
      `[${type} Effect] Turn Microphone On Failed As Not Available`,
    ),
    turnMicrophoneAndCameraOnClicked: createAction(
      `[${type}] Turn Microphone And Camera On Clicked`,
    ),
    turnMicrophoneAndCameraOnSucceeded: createAction(
      `[${type} Effect] Turn Microphone And Camera On Succeeded`,
    ),
    turnMicrophoneAndCameraOnFailed: createAction(
      `[${type} Effect] Turn Microphone And Camera On Failed`,
      props<DeviceActivationFailedProps>(),
    ),
    turnMicrophoneAndCameraOnFailedAsNotAvailable: createAction(
      `[${type} Effect] Turn Microphone And Camera On Failed As Not Available`,
    ),
    toggleMicrophoneActiveClicked: createAction(`[${type}] Toggle Microphone Active Clicked`),
    toggleMicrophoneActiveSucceeded: createAction(
      `[${type} Effect] Toggle Microphone Active Succeeded`,
    ),
    toggleMicrophoneFailed: createAction(
      `[${type} Effect] Toggle Microphone Failed`,
      props<DeviceActivationFailedProps>(),
    ),
    toggleMicrophoneFailedAsNotAvailable: createAction(
      `[${type} Effect] Toggle Microphone Failed As Not Available`,
    ),
    toggleCameraActiveClicked: createAction(`[${type}] Toggle Camera Active Clicked`),
    toggleCameraActiveSucceeded: createAction(`[${type} Effect] Toggle Camera Active Succeeded`),
    toggleCameraFailed: createAction(
      `[${type} Effect] Toggle Camera Failed`,
      props<DeviceActivationFailedProps>(),
    ),
    toggleCameraFailedAsNotAvailable: createAction(
      `[${type} Effect] Toggle Camera Failed As Not Available`,
    ),
    cameraActiveChanged: createAction(
      `[${type} Effect] Camera Active Changed`,
      props<{ active: boolean }>(),
    ),
    microphoneActiveChanged: createAction(
      `[${type} Effect] Microphone Active Changed`,
      props<{ active: boolean }>(),
    ),
    deactivateMicrophoneSucceeded: createAction(`[${type} Effect] Deactivate Microphone Succeeded`),
    deactivateMicrophoneErrored: createAction(
      `[${type} Effect] Deactivate Microphone Errored`,
      props<{ reason: RequestMediaFailedReason }>(),
    ),
    deactivateCameraSucceeded: createAction(`[${type} Effect] Deactivate Camera Succeeded`),
    deactivateCameraErrored: createAction(
      `[${type} Effect] Deactivate Camera Errored`,
      props<{ reason: RequestMediaFailedReason }>(),
    ),
    requestMediaSucceeded: createAction(`[${type} Effect] Request Media Succeeded`),
    requestMediaErrored: createAction(
      `[${type} Effect] Request Media Errored`,
      props<{ error: any }>(),
    ),
    videoConnectionProgressPercentageUpdated: createAction(
      `[${type} Effect] Video Connection Progress Percentage Updated`,
      props<{ percentage: number }>(),
    ),
    transcriptUpdated: createAction(
      `[${type} Effect] Transcript Updated`,
      props<{ entry: TranscriptEntry }>(),
    ),
    viewDestroyed: createAction(`[${type} Page] View Destroyed`),
    speakTriggered: createAction(`[${type}] Speak Triggered`, props<{ script: string }>()),
    speakSucceeded: createAction(`[${type} Effect] Speak Succeeded`),
    speakErrored: createAction(`[${type} Effect] Speak Errored`),
    speechStarted: createAction(`[${type} Effect] Speech Started`),
    speechFinished: createAction(`[${type} Effect] Speech Finished`),
    serverDisconnected: createAction(`[${type} Effect] Server Disconnected`),
  };
}

export type VideoActions = ReturnType<typeof createVideoActions>;
